import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useNavigate, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

export default function Pagamentos() {
    const navigate = useNavigate();
    const location = useLocation();

    // Determina o valor da aba com base no caminho atual da URL
    let value = 0;
    if (location.pathname.endsWith('/pagamentos-csv-xlsx')) {
        value = 1;
    } 
    
    // Se a rota for '/producao/gerar', o valor padrão (0) é mantido.

    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            navigate('/pagamentos/pagamentos-verificar');
        } else if (newValue === 1) {
            navigate('/pagamentos/pagamentos-csv-xlsx');
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="Abas de Cupons">
                    <Tab label="Verificar" />
                    <Tab label="Ler csv xlsx" />
                </Tabs>
            </Box>
            {/* O Outlet renderizará o conteúdo do componente da rota aninhada */}
            <Outlet />
        </Box>
    );
}